export const safeFeeFloat = (value: string) => {
  if (!value) return 0;

  const parsed = parseFloat(value);
  return Number.isNaN(parsed) ? 0 : parsed;
};
